import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { compose } from "redux";
import CustomDataTable from "components/Application/CustomDataTable";

const columns = [
  {
    label: "Product Name",
    field: "productName",
  },
  {
    label: "Product Unit",
    field: "productUnit",
  },
  {
    label: "MRP",
    field: "productMrp",
  },
  {
    label: "Selling Price",
    field: "productSp",
  },
  {
    label: "Qty",
    field: "qty",
  },
  {
    label: "Total Amount",
    field: "totalAmount",
  },
];

class OrderDetailItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderItemRecords: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (nextprops.orderItemData !== this.props.orderItemData) {
      this.buildOrderDataTable(nextprops.orderItemData);
    }
  }

  buildOrderDataTable = (records) => {
    this.setState({
      orderItemRecords: records.map((orderItem) => {
        return {
          productName: orderItem.productName,
          productUnit: orderItem.unit,
          productMrp: <del>{orderItem.unitMrp}</del>,
          productSp: orderItem.unitSp,
          qty: orderItem.qty,
          totalAmount: orderItem.totalSp,
        };
      }),
    });
  };

  componentDidMount() {
    this.buildOrderDataTable(this.props.orderItemData);
  }

  render() {
    const data = {
      columns: columns,
      rows: this.state.orderItemRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

export default compose(withRouter)(OrderDetailItems);
